import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.js";

const chartsStyle = {
  cardTitle,
  cardCategory: {
    margin: "0",
    color: grayColor[0]
  },
  cardIconTitleSimpleCard: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontSize: "0.9rem",
    fontWeight: "600",
    opacity: "0.9",
  },
  cardIconTitleSimpleCardDark: {
    ...cardTitle,
    marginTop: "10px",
    marginBottom: "0px",
    fontSize: "0.9rem",
    fontWeight: "600",
    marginLeft: "10px",
    opacity: "0.9",
    color: "#FFFFFF"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontSize: "15px",
  },
  cardIconTitleDark: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontSize: "15px",
    color: "#FFFFFF"
  },
  cardIcon: {
    padding: "5px",
  },
  legendTitle: {
    color: grayColor[0],
    margin: "10px 0 !important",
    display: "flex"
  },
  primary: {
    color: primaryColor[0]
  },
  warning: {
    color: warningColor[0]
  },
  danger: {
    color: dangerColor[0]
  },
  success: {
    color: successColor[0]
  },
  info: {
    color: infoColor[0]
  },
  rose: {
    color: roseColor[0]
  },
  gray: {
    color: grayColor[0]
  },
  cardFooter: {
    display: "block"
  }
};

export default chartsStyle;
